import React from 'react';

/**
 * Extracts the YouTube video ID from various URL formats
 */
export const getYouTubeVideoId = (url: string): string | null => {
  if (!url) return null;

  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\s?]+)/,
    /youtube\.com\/shorts\/([^&\s?]+)/,
  ];

  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match && match[1]) {
      return match[1];
    }
  }
  return null;
};

/**
 * Converts a YouTube URL to an embed URL
 */
export const getYouTubeEmbedUrl = (url: string): string | null => {
  const videoId = getYouTubeVideoId(url);
  return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
};

interface YouTubeEmbedProps {
  url: string;
  title: string;
  borderRadius?: number;
}

/**
 * Responsive YouTube video embed component with 16:9 aspect ratio
 */
export const YouTubeEmbed: React.FC<YouTubeEmbedProps> = ({
  url,
  title,
  borderRadius = 8,
}) => {
  const embedUrl = getYouTubeEmbedUrl(url);

  if (!embedUrl) {
    return null;
  }

  return (
    <div className="youtube-embed-container" style={{ borderRadius }}>
      <iframe
        src={embedUrl}
        title={title}
        className="youtube-embed-iframe"
        style={{ borderRadius }}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
};
